import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box, ClickAwayListener } from "@mui/material"
import { TooltipSeeker } from "@ui-seeker/core"

import PricingCandlestickTooltipBody from "./Body"


export default function PricingCandlestickTooltip({ bottom, left, width, height, discount, numSkus, groupedID, externalSeller, children }) {
	const isOpen = useSignal(false)

	const handleClose = () => isOpen.value = false

	return <ClickAwayListener onClickAway={handleClose}>
		<Box sx={{ display: 'inline-block', position: 'absolute', bottom, left, width, height }}>
			<TooltipSeeker
				useLight
				title={<PricingCandlestickTooltipBody
					discount={discount}
					numSkus={numSkus}
					groupedID={groupedID}
					onCloseTooltip={handleClose}
					externalSeller={externalSeller}
				/>}
				onClose={handleClose}
				placement="right"
				open={isOpen.value}
				disableFocusListener
				disableHoverListener
				disableTouchListener
			>
				<Box component="span" onClick={() => isOpen.value = true} sx={{ '&:hover': { cursor: 'pointer' } }}>
					{children}
				</Box>
			</TooltipSeeker>
		</Box>
	</ClickAwayListener>
}